// extracted by mini-css-extract-plugin
module.exports = {"backgroundWrapper":"bottomHeader_backgroundWrapper__3ESFS"};